export const SITEINFORMATION_LIST_SUCCESS = 'SITEINFORMATION_LIST_SUCCESS';
export const SITEINFORMATION_LIST_FAILURE = 'SITEINFORMATION_LIST_FAILURE';

export const SITEINFORMATION_DATA_SUCCESS = 'SITEINFORMATION_DATA_SUCCESS';
export const SITEINFORMATION_DATA_FAILURE = 'SITEINFORMATION_DATA_FAILURE';
